import { render } from "./MarketingData.vue?vue&type=template&id=b4bd7476&scoped=true"
import script from "./MarketingData.vue?vue&type=script&lang=js"
export * from "./MarketingData.vue?vue&type=script&lang=js"

import "./MarketingData.vue?vue&type=style&index=0&id=b4bd7476&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4bd7476"]])

export default __exports__